// UR Brand System — Phase 5b API helpers.
// Keeps page components focused on UX. Backends:
//   • Admin: cookies (admin_session) + Bearer header fallback.
//   • Customer: X-Project-Token header from URL ?token=
//   • Designer: X-Designer-Token header from localStorage.
import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;

export function adminApi() {
  const sessionToken = typeof document !== "undefined"
    ? (document.cookie.match(/admin_session=([^;]+)/) || [])[1]
    : null;
  return axios.create({
    baseURL: `${BASE}/api`,
    withCredentials: true,
    headers: sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {},
  });
}

export function customerApi(projectToken) {
  return axios.create({
    baseURL: `${BASE}/api/brand-direction`,
    headers: projectToken ? { "X-Project-Token": projectToken } : {},
  });
}

export function designerApi() {
  const t = typeof localStorage !== "undefined"
    ? localStorage.getItem("ur_designer_token") : null;
  return axios.create({
    baseURL: `${BASE}/api/designer`,
    headers: t ? { "X-Designer-Token": t } : {},
  });
}

export const GATE1_CRITERIA = [
  ["strategic_fit", "Strategic Fit"],
  ["creative_quality", "Creative Quality"],
  ["distinctiveness", "Distinctiveness"],
  ["technical_quality", "Technical Quality"],
  ["originality_ownership", "Originality / Ownership"],
  ["font_licensing", "Font / Licensing"],
  ["ur_designs_standard", "Ur Designs Standard"],
];
export const GATE2_CRITERIA = [
  ["identity_approved_bound", "Identity"],
  ["files_complete", "Files"],
  ["blueprint_bound", "Blueprint"],
  ["licensing_source_verified", "Licensing"],
  ["ur_designs_delivery_standard", "Ur Designs Standard"],
];

export function overallFrom(checklist, criteria) {
  return criteria.every(([k]) => checklist[k] === "PASS") ? "PASS" : "NEEDS_WORK";
}
